import { addLocstringsToStore } from './addLocstringsToStore';
import { setLocale } from './setLocale';

export async function initializeLocalization(
    locale: string,
    prefetchedStrings?: Record<string, string>
) {
    await setLocale(locale);

    if (prefetchedStrings) {
        addLocstringsToStore(prefetchedStrings);
    }
}
